import { render } from "./IconAlertTriangleStroke.vue?vue&type=template&id=205f3f7d"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconAlertTriangleStroke.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "205f3f7d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('205f3f7d', __exports__)) {
    api.reload('205f3f7d', __exports__)
  }
  
  module.hot.accept("./IconAlertTriangleStroke.vue?vue&type=template&id=205f3f7d", () => {
    api.rerender('205f3f7d', render)
  })

}


export default __exports__